module.exports = __webpack_public_path__ + "img/product.665d2b2d.png";